import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AjaxHelper } from '../helper/ajax.helper';
import { BaseResponse } from '../model/base.response';
import { WebConstants } from '../util/web.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GeofenceService {
  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper,
    private httpClient: HttpClient) {
  }

  getAll(): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GEOFENCE.FIND_ALL_GEOFENCE);
  }

  addGeofence(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE.ADD_GEOFENCE, payload);
  }

  updateGeofence(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE.UPDATE_GEOFENCE, payload);
  }

  deleteGeofence(geofenceId: Number): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE.DELETE_GEOFENCE + geofenceId, geofenceId);
  }

  deleteGeofenceWithDetails(geofenceId: Number): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE.DELETE_GEOFENCE_WITH_DETAILS + geofenceId, geofenceId);
  }

  addBulkGeofence(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE.ADD_BULK_GEOFENCE, payload);
  }

  addBulkGeofenceDetails(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_DETAIL.ADD_BULK_GEOFENCE_DETAIL, payload);
  }

  // getGeofenceById(geofenceId: Number): Observable<BaseResponse<any>> {
  //   return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GEOFENCE.FIND_GEOFENCE_BY_ID + geofenceId);
  // }
}
